import { useEffect, useState } from 'react';
import { formatDistanceStrict } from 'date-fns';
import { enhanceDistance } from '../utils/enhanceDistance';
import { getPromptStatusConfig } from '../../Prompt/utils/getPromptStatusConfig';
import { PromptSettingsLiveStatus } from '../../Prompt/constants';

export const useDistanceTimer = (startDate: string, endDate: string, status: PromptSettingsLiveStatus): string => {
  const [displayDistanceText, setDisplayDistanceText] = useState('');

  const currentDate = new Date();

  const promptStatusConfig = getPromptStatusConfig(startDate, endDate);
  const { prefix, suffix, baseDate } = promptStatusConfig[status];

  const distance = formatDistanceStrict(currentDate, baseDate);

  useEffect(() => {
    const displayDistance =
      status === PromptSettingsLiveStatus.COMPLETED
        ? `${enhanceDistance(distance)}${suffix}`
        : enhanceDistance(distance);
    setDisplayDistanceText(displayDistance);
  }, [distance, status]);

  const formattedDistanceText = `${prefix} ${displayDistanceText}`;

  return formattedDistanceText;
};
